import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=a211d230&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=a211d230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a211d230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a211d230')) {
      api.createRecord('a211d230', component.options)
    } else {
      api.reload('a211d230', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=a211d230&scoped=true&", function () {
      api.rerender('a211d230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Home/Dashboard.vue"
export default component.exports